import React from "react";
import { Switch, Route, Redirect, useRouteMatch } from "react-router-dom";
import LoginForm from "../users/auth/LoginForm";
import Onboard from "../users/auth/Onboard";
import ResetRequest from "../users/auth/ResetRequest";
import VerifyCode from "../users/auth/VerifyCode";
import ResetPassword from "../users/auth/ResetPassword";
import VerifyAccount from "../users/auth/VerifyAccount";

function AuthRoute(props) {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/signin`} component={LoginForm} />
      <Route path={`${path}/signup`} component={Onboard} />
      <Route
        path={`${path}/reset-password/request`}
        children={({ match, history }) => (
          <ResetRequest open={Boolean(match)} onClose={history.goBack} />
        )}
      />
      <Route
        path={`${path}/reset-password/verify`}
        children={({ match, history }) => (
          <VerifyCode open={Boolean(match)} onClose={history.goBack} />
        )}
      />
      <Route
        path={`${path}/reset-password`}
        children={({ match, history }) => (
          <ResetPassword open={Boolean(match)} onClose={history.goBack} />
        )}
      />
      <Route path={`${path}/verify`} component={VerifyAccount} />
      <Redirect from={`${path}`} to={`${path}/signin`} />
    </Switch>
  );
}

export default AuthRoute;
